/**
 * パラメータ関連
 */
(()=>{

	let param	= nsOiOi.param;
	let gv_cons = nsOiOi.cons;
	let gv_util = nsOiOi.util;

	/** 
	 * 共通エレメントにパラメータを付与
	*/
	param.addParamCommonElement = (aPageType = '') => {
		const device	= gv_util.getDeviceUa();
		const storeCode	= gv_util.getStoreCode();
		let page;

		if(!aPageType) {
			page = gv_util.getPageType();
		} else {
			page = aPageType;
		}

		_.each(gv_cons.PARAM_COMMON_MASTER, (aType, aSelector) => {
			let linkElem = $(aSelector).find('a');

			if($.inArray(page, Object.keys(gv_cons.CONV_PARAM_PAGE_KEY)) !== -1) {
				page = `st${storeCode}_${gv_cons.CONV_PARAM_PAGE_KEY[page]}`;
			}
			_.each(linkElem, (aLinkIn) => {
				let addParam;
				let resultUrl;
				let linkStr		= gv_util.makeUrlSiteInner($(aLinkIn).attr('href'), device);
				let linkSite	= gv_util.getSiteUrlType(linkStr);
				let paramKey	= gv_cons.PARAM_KEY_GROUP[linkSite];
				let paramHead	= gv_cons.PARAM_HEAD_STR[linkSite]
				addParam		= `${paramHead}_${device}_${page}_${aType}`;
				resultUrl		= gv_util.addUrlParam(linkStr, paramKey, addParam, true);
				$(aLinkIn).attr('href', resultUrl);

			});
		});
	};

	/**
	 * ページ共通のエレメントにパラメータを付与
	 * @param {String} aPageType	- ページ名称
	 */
	param.addParamPageElement = (aPageType = '')=> {
		const device	= gv_util.getDeviceUa();
		const storeCode	= gv_util.getStoreCode();
		let page;

		if(!aPageType) {
			page = gv_util.getPageType();
		} else {
			page = aPageType;
		}
		_.each(gv_cons.PARAM_PAGE_MASTER[page], (aType, aSelector) => {
			if($.inArray(page, Object.keys(gv_cons.CONV_PARAM_PAGE_KEY)) !== -1) {
				page = `st${storeCode}_${gv_cons.CONV_PARAM_PAGE_KEY[page]}`;
			}

			let linkElem	= $(aSelector).find('a');
			_.each(linkElem, (aLinkIn, idx) => {
				let linkHref		= $(aLinkIn).attr('href');
				if(!linkHref) {
					return;
				}
				let addParam;
				let resultUrl;
				let linkStr			= gv_util.makeUrlSiteInner(linkHref, device);
				let linkSite		= gv_util.getSiteUrlType(linkStr);
				let paramKey		= gv_cons.PARAM_KEY_GROUP[linkSite];
				let paramHead		= gv_cons.PARAM_HEAD_STR[linkSite];
				let linkParamObj 	= gv_util.getArgUrlQueryParam(linkHref);
				let replaceParam;
				let artcleId		= gv_util.getParamFromUrl(gv_cons.PAGE_PARAM_ARTICLE_ID[aPageType]);
				let isOuterLink		= gv_util.checkLinkUrlOuter(linkHref);
				let isGroupLink		= gv_util.checkLinkGroupSite(linkHref);
				idx++;
				replaceParam	= aType
									.replace('【idx】', idx)
									.replace('【num】', artcleId);
				addParam		= `${paramHead}_${device}_${page}_${replaceParam}`;

				// 既にcid設定があるURLはそのまま利用
				if(_.contains(Object.keys(linkParamObj), 'cid')) {
					resultUrl		= gv_util.addUrlParam(linkStr, 'cid', linkParamObj.cid + '_' + idx, true);
				} else {
					resultUrl		= gv_util.addUrlParam(linkStr, paramKey, addParam, true);
				}

				if(!isOuterLink) {
					$(aLinkIn).attr('href', resultUrl);
				} else if(isGroupLink) {
					$(aLinkIn).attr({
						href	: resultUrl,
						target	: '_blank',
					});
				} else {
					$(aLinkIn).attr('target', '_blank');
				}

			});
		});
	};

})();